import React, { useState } from 'react';
import './SearchBar.css';

const SearchBar = ({ onSearch, placeholder = "Search blocks, transactions, tokens, contracts..." }) => {
  const [query, setQuery] = useState('');
  const [isSearching, setIsSearching] = useState(false);

  const detectSearchType = (input) => {
    const trimmed = input.trim();
    
    // Block number (numeric)
    if (/^\d+$/.test(trimmed)) {
      return { type: 'block', value: parseInt(trimmed) };
    }
    
    // Transaction hash (0x + 64 hex chars)
    if (/^0x[a-fA-F0-9]{64}$/.test(trimmed)) {
      return { type: 'transaction', value: trimmed };
    }
    
    // Address/Contract (0x + 40 hex chars)
    if (/^0x[a-fA-F0-9]{40}$/.test(trimmed)) {
      return { type: 'address', value: trimmed };
    }
    
    // Block hash (0x + 64 hex chars, same as tx hash)
    if (/^0x[a-fA-F0-9]{64}$/.test(trimmed)) {
      return { type: 'block_hash', value: trimmed };
    }
    
    // Partial hash search
    if (/^0x[a-fA-F0-9]+$/.test(trimmed) && trimmed.length > 10) {
      return { type: 'partial_hash', value: trimmed };
    }
    
    // Token symbol or name search
    if (/^[a-zA-Z][a-zA-Z0-9]*$/.test(trimmed)) {
      return { type: 'token', value: trimmed.toUpperCase() };
    }
    
    return { type: 'unknown', value: trimmed };
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!query.trim()) return;

    setIsSearching(true);
    const searchData = detectSearchType(query);
    
    try {
      if (onSearch) {
        await onSearch(query, searchData);
      }
    } catch (error) {
      console.error('Search error:', error);
    } finally {
      setIsSearching(false);
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    
    // Trigger search on every character for real-time results
    if (onSearch) {
      const searchData = detectSearchType(value);
      onSearch(value, searchData);
    }
  };

  const handleClear = () => {
    setQuery('');
    if (onSearch) {
      onSearch('');
    }
  };

  return (
    <div className="search-bar-minimal">
      <form onSubmit={handleSearch} className="search-form-minimal">
        <div className="search-input-container">
          <input
            type="text"
            value={query}
            onChange={handleInputChange}
            placeholder={placeholder}
            className="search-input-minimal"
            disabled={isSearching}
          />
          
          {query && (
            <button
              type="button"
              onClick={handleClear}
              className="search-clear-btn"
              aria-label="Clear search"
            >
              ×
            </button>
          )}
          
          <button
            type="submit"
            className="search-submit-btn"
            disabled={isSearching || !query.trim()}
            aria-label="Search"
          >
            {isSearching ? '...' : 'Search'}
          </button>
        </div>
        
        {query && (
          <div className="search-type-indicator">
            Searching for: {detectSearchType(query).type.replace('_', ' ')}
          </div>
        )}
      </form>
    </div>
  );
};

export default SearchBar;